import { SessionResponse } from "../contracts/SessionResponse";
import { InviteeResponse } from "../contracts/InviteeResponse";
import { Session } from "../models/Session";
import { Invitee } from "../models/Invitee";

export class SessionResponseMapper {
  /**
   * Converts a SessionResponse to a Session model
   * @param resp - The session response from the API
   * @returns The converted Session model
   */
  toSession = (resp: SessionResponse): Session => {
    return {
      id: resp.id,
      paymentActivityType: resp.paymentActivityType,
      title: resp.title,
      description: resp.description,
      dateStart: resp.dateStart,
      timeLocal: resp.timeLocal,
      timeZone: resp.timeZone,
      duration: resp.duration,
      isAllDay: resp.isAllDay,
      status: resp.status,
      recurrenceType: resp.recurrenceType,
      recurrenceDays: resp.recurrenceDays,
      recurrenceDaysNumber: resp.recurrenceDaysNumber,
      recurrenceDateEnd: resp.recurrenceDateEnd
        ? new Date(resp.recurrenceDateEnd)
        : undefined,
      finishAfterOccurrences: resp.finishAfterOccurrences,
      remindBefore: resp.remindBefore,
      invitees: resp.invitees.map(this.toInvitee),
      dateCreated: resp.dateCreated,
      dateModified: resp.dateModified,
    };
  };

  /**
   * Converts multiple SessionResponse objects to Session models
   * @param responses - Array of session responses from the API
   * @returns Array of converted Session models
   */
  toSessions = (responses: SessionResponse[]): Session[] => {
    return responses.map(this.toSession);
  };

  /**
   * Converts an InviteeResponse to an Invitee model
   * @param resp - The invitee response from the API
   * @returns The converted Invitee model
   */
  toInvitee = (resp: InviteeResponse): Invitee => {
    return {
      id: resp.id,
      invitedUserId: resp.invitedUserId,
      bookingId: resp.bookingId,
      type: resp.type,
      dateCreated: new Date(resp.dateCreated),
      dateModified: new Date(resp.dateModified),
    };
  };
}
